import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconKey24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.383 10.968 4.207 2.793 2.793 4.207 4.086 5.5 2.293 7.293l1.414 1.414L5.5 6.914 7.086 8.5l-1.793 1.793 1.414 1.414L8.5 9.914l2.468 2.468a5.5 5.5 0 1 0 1.414-1.414M15.5 19a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconKey24);
export default ForwardRef;
